import { render, staticRenderFns } from "./region-select.vue?vue&type=template&id=91f98a20&scoped=true"
import script from "./region-select.ts?vue&type=script&lang=js&external"
export * from "./region-select.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f98a20",
  null
  
)

export default component.exports